/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import {
  ChatMessageBody,
  ChatMessageFooter,
  ChatMessageHeader,
} from 'bundles/ai-coach-platform/components/patterns/chat/common';
import ChatRecommendations from 'bundles/ai-coach-platform/components/patterns/chat/recommendations/ChatRecommendations';
import type { CoachPersona, SendMessageFunc } from 'bundles/ai-coach-platform/components/patterns/chat/types';

import type { MessageTypes } from './store/types';
import {
  isCoachMessage as isCoachMessageUtil,
  isErrorMessage as isErrorMessageUtil,
  isTextMessage as isTextMessageUtil,
} from './utils/messageUtils';

export type Props = {
  message: MessageTypes;
  index: number;
  messages: MessageTypes[];
  sendMessage: SendMessageFunc;
  learnerPersona: CoachPersona;
  coachPersona: CoachPersona;
};

const styles = {
  footer: () => css`
    justify-content: end;
  `,
};

const ChatMessageV2 = ({ message, index, messages, sendMessage, coachPersona, learnerPersona }: Props) => {
  const { sender } = message;

  const isLastMessage = index === messages.length - 1;
  const isCoachMessage = isCoachMessageUtil(sender);
  const persona = isCoachMessage ? coachPersona : learnerPersona;

  // only allow Coach text messages to be copied
  const showCopyMessage = isCoachMessage && isTextMessageUtil(message as MessageTypes);
  const isErrorMessage = isCoachMessage && isErrorMessageUtil(message as MessageTypes);

  return (
    <>
      <ChatMessageHeader senderName={persona.name} senderAvatar={persona.avatar} />

      <ChatMessageBody message={message} className="coach-chat-message-body">
        {isCoachMessage ? (
          <ChatRecommendations message={message} sendMessage={sendMessage} showRecommendedActions={isLastMessage} />
        ) : null}
      </ChatMessageBody>

      {/* hide message actions for Coach error messages */}
      {isCoachMessage && !isErrorMessage && (
        <ChatMessageFooter showCopyMessage={showCopyMessage} css={styles.footer} message={message} />
      )}
    </>
  );
};

export default ChatMessageV2;
